module.exports = __webpack_public_path__ + "static/media/typed.58a3edc2.jpg";